import { getFunctionalModules } from "../../services/header/header.service";
import { ResponsiveService } from "../../services/responsive/responsive.service";
import HeaderDesktop from "./HeaderDesktop.component";
import HeaderResponsive from "./HeaderResponsive.component";

const Header = () => {
	const routes = getFunctionalModules();

	return (
		<>
			{ResponsiveService.isDesktop() ? (
				<HeaderDesktop routes={routes} />
			) : (
				<HeaderResponsive routes={routes} />
			)}
		</>
	);
};
export default Header;
